import { Modal, List, Button, Popconfirm, Typography, Empty } from "antd";
import React from "react";
import type { Carpool, CarpoolRole } from "../types";
import type { CarpoolStore } from "../store";

interface Props {
  store: CarpoolStore;
  carpool: Carpool;
  open: boolean;
  onClose: () => void;
}

const HEADING: Record<CarpoolRole, (carpool: Carpool) => string> = {
  driver: (carpool) => `Mitfahranfragen (${carpool.joinRequests.length} / ${carpool.seats ?? 0})`,
  rider: (carpool) => `Fahrtangebote (${carpool.joinRequests.length})`,
  train: (carpool) => `Kontaktanfragen (${carpool.joinRequests.length})`,
};

const EMPTY_LABEL: Record<CarpoolRole, string> = {
  driver: "Noch keine Anfragen",
  rider: "Noch keine Angebote",
  train: "Noch keine Anfragen",
};

const REMOVE_CONFIRM_TITLE: Record<CarpoolRole, string> = {
  driver: "Platz wieder freigeben?",
  rider: "Angebot entfernen?",
  train: "Anfrage entfernen?",
};

export const EditCarpoolModal = ({ store, carpool, open, onClose }: Props) => {
  const handleRemoveRequest = async (index: number) => {
    await store.removeJoinRequest(carpool.objectId!, index);
  };

  const handleDelete = async () => {
    await store.deleteCarpool(carpool.objectId!);
    onClose();
  };

  return (
    <Modal
      open={open}
      title={`Fahrt bearbeiten: ${carpool.origin} → ${carpool.destination}`}
      footer={[
        <Popconfirm
          key="delete"
          title="Fahrt wirklich löschen?"
          onConfirm={handleDelete}
          okText="Ja"
          cancelText="Nein"
        >
          <Button danger>Fahrt löschen</Button>
        </Popconfirm>,
        <Button key="close" onClick={onClose}>
          Schließen
        </Button>,
      ]}
      onCancel={onClose}
    >
      <Typography.Text strong>{HEADING[carpool.role](carpool)}</Typography.Text>
      {carpool.joinRequests.length === 0 ? (
        <Empty
          description={EMPTY_LABEL[carpool.role]}
          style={{ margin: "16px 0" }}
        />
      ) : (
        <List
          style={{ marginTop: 8 }}
          dataSource={carpool.joinRequests}
          renderItem={(req, index) => (
            <List.Item
              actions={[
                <Popconfirm
                  key="remove"
                  title={REMOVE_CONFIRM_TITLE[carpool.role]}
                  onConfirm={() => handleRemoveRequest(index)}
                  okText="Ja"
                  cancelText="Nein"
                >
                  <Button size="small" danger>
                    Entfernen
                  </Button>
                </Popconfirm>,
              ]}
            >
              <List.Item.Meta title={req.name} description={`Angefragt am ${new Date(req.requestedAt).toLocaleDateString("de-DE")}`} />
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};
